import { useCallback } from 'react';
import { useAuth } from '../context/AuthContext';

/** Formats an amount in the school's currency, e.g. "PKR 25,000". */
export const useCurrencyFormat = () => {
  const { currency } = useAuth();
  return useCallback(
    (n: number) => `${currency || ''} ${n.toLocaleString(undefined, { maximumFractionDigits: 2 })}`.trim(),
    [currency],
  );
};
